<template>
    <div class="calendar-view has-header">
        <div class="header">
        </div>
        <dateselectionheader
                :label="selectedYear.format('YYYY')"
                @PrevDate="PreviousDate()"
                @NextDate="NextDate()"
                @SetToday="SetDateToCurrentDay()"/>
        <div class="scrollbar-container">
            <div class="grid">
                <div class="column" v-for="(column, indexC) in columns" :key="indexC" v-bind:class="{today: today.month() === indexC}">
                    <div class="header">
                        <div class="today-background"></div>
                        <div class="label">{{column.header.label}}</div>
                    </div>
                    <div class="row" v-for="(row, indexR) in column.rows" :key="indexR" v-bind:class="{'no-event': !row.events || row.events.length === 0, today: today.date() === indexR + 1, hide: row.employees.length === 0}" v-on:click="OpenCalendarPopup($event, column, row)">
                        <div class="header" v-if="indexC === 0">
                            <div class="label">{{row.header.label}}</div>
                        </div>
                        <div class="holiday" v-if="row.holidayCount > 0" v-bind:style="{width: (17 + ((row.holidayCount - 1) * 15)) + 'px'}">{{row.holidayCount}}</div>
                        <div class="holiday-request" v-if="row.holidayRequestCount > 0">{{row.holidayRequestCount}}</div>
                        <div class="sick" v-if="row.sickCount > 0">{{row.sickCount}}</div>
                        <div class="info" v-if="row.holidayName">
                            <div class="label">{{row.holidayName}}</div>
                            <div class="shadow"></div>

                        </div>
                        <div class="event new" v-if="!(row.events && row.events.length > 0)">
                            <div class="fa-stack add" v-on:click="AddEvent($event, row.date)">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-plus fa-stack-2x"></i>
                            </div>
                        </div>
                        <div class="event" v-if="row.events && row.events.length > 0">
                            <div class="container" v-for="(event, indexE) in row.events" :key="indexE">
                                <div class="label">{{event ? event.header : ''}}</div>
                                <div class="label shadow"></div>
                                <div class="fa-stack edit" v-on:click="EditEvent($event, event.event)">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-edit fa-stack-2x"></i>
                                </div>
                                <div class="fa-stack delete" v-on:click="ConfirmEventDelete($event, event.event)">
                                    <i class="fas fa-circle fa-stack-2x"></i>
                                    <i class="fas fa-trash fa-stack-2x"></i>
                                </div>
                                <div class="color" v-bind:style="{background: event.event.color}"></div>
                            </div>
                            <div class="fa-stack add" v-on:click="AddEvent($event, row.date)">
                                <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fas fa-plus fa-stack-2x"></i>
                            </div>
                        </div>
                        <div class="today-border"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="event-info" v-if="eventOnHover" v-bind:style="{left: eventBoxX + 'px',top: eventBoxY + 'px'}">
            <div class="header">{{eventOnHover.header}}</div>
            <div class="description">{{eventOnHover.description}}</div>
        </div>
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
        <calendarpopup ref="calendarpopup" :state="dayInfoState"/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import calendarpopup from '../preferencecontext/CalendarInfoPopup.vue'
    export default {
        name: 'calenderview',
        components: {
            calendarpopup,
        },
        data(){
            return{
                displayedTimeframe: 'Year',
                eventOnHover: null,
                mouseX: 0,
                mouseY: 0,
                today: this.$helpers.getMomentTZ(),
                employees: [],
                employeesFiltered: [],
                employeeMap: {},
                preferences: [],
                businessUnits: [],
                businessUnitsMap: {},
                spots: [],
                spotMap: {},
                uiData: [],
                employeeAvailabilityStateMap: {},
                employeeAvailabilityTypeMap: {},
                loading: true,
                loadingText: '',
                eventBoxX: '',
                eventBoxY: '',
                dayInfoState: {
                    toggled: false,
                    column: null,
                    row: null,
                    employees: [],
                    event: null,
                    elRelative: null,
                    preferences: [],
                    date: this.$helpers.getCurrentMonthMomentTZ(),
                },
                storeEventMap: {},
                selectedYear: this.$helpers.getMomentTZStartOfDay().dayOfYear(1),
            }
        },
        computed: {
             ...mapGetters([
                'storeSettings',
                
            ]),
            columns () {
                var view = this;
                var columns = [];
                for(var x = 0; x < 12; x++){
                    var dateColumn = this.selectedYear.clone().locale('de').month(x);
                    var column = {header: {label: dateColumn.format('MMMM')}, date: dateColumn};
                    var rows = [];
                    for(var y = 1; y < this.selectedYear.clone().month(x).daysInMonth() + 1; y++){
                        var row = {header: {label: y < 10 ? '0' + y : y.toString()}};
                        var date = row.date = this.selectedYear.clone().month(x).date(y).hours(0).minutes(0).seconds(0).milliseconds(0);
                        let dateTo = date.clone().add(1, 'days');
                        var preferencesDate = this.preferences.filter(p => p.fromDate < dateTo && p.toDate > row.date);
                        row.holidayCount = preferencesDate.filter(p => p.state === 1 && p.type === 1 && p.approved).length;
                        row.holidayRequestCount = preferencesDate.filter(p => p.state === 1 && p.type === 1 && !p.approved).length;
                        row.sickCount = preferencesDate.filter(p => p.state === 1 && p.type === 2).length;
                        var events = Object.values(this.storeEventMap).filter(entry => entry.fromMoment < dateTo && entry.toMoment > date);

                        row.events = [];
                        let holiday = events.find(e => e.federalHoliday);
                        if(holiday) row.holidayName = holiday.name;
                        events = events.filter(e => !e.federalHoliday);
                        events.forEach(e => row.events.push({header: e.name, description: e.name, event: e}));
                        row.info = 'Row';
                        row.employees = this.employees.filter(e => preferencesDate.find(p => p.employeeId === e.id));
                        rows.push(row);
                    }
                    column.rows = rows;
                    columns.push(column);
                }
                return columns;
            },
            rosterFromTo() {
                if(this.$store.state.loggedIn){
                    return this.$store.state.rosterFromTo;
                } else {
                    return null;
                }    
            },
            storeId() {
                return this.$store.state.storeId;
            },
        },
        watch: {
            rosterFromTo(newVal, oldVal) {
                if(newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                    this.refresh();
                }
            },
            storeId(newVal, oldVal) {
                console.log("Changed storeId: "+newVal);
                this.refresh();
            }
        },
        created() {
            
            if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                this.refresh();
            }
            
            window.calendarview = this;
        },
        mounted() {
        },
        beforeDestroy(){

            if(this.$refs.calendarpopup && this.$refs.calendarpopup.$el) $(this.$refs.calendarpopup.$el).remove();
        },
        methods: {
            PreviousDate(){
                this.selectedYear.add(-1, 'year');
                this.$forceUpdate();
            },
            NextDate(){
                this.selectedYear.add(1, 'year');
                this.$forceUpdate();
            },
            SetDateToCurrentDay(){
                if(this.selectedYear.year() !== this.today.year()) {
                    this.selectedYear = this.$helpers.getMomentTZStartOfDay().dayOfYear(1);
                    this.$forceUpdate();
                }
            },
            ConfirmEventDelete($event, storeEvent){
                
                let view = this;
                window.app.popupalerts.push({header: this.$t('store.events.deleteEvent'), description: this.$t('global.ui.deleteQuery'), callbackAccept: function(popup){
                        //popup.loading = true;
                        view.deleteStoreEvent(storeEvent);
                        popup.hidden = true;
                    }, callbackCancel: function(popup){
                        popup.loading = false;
                        popup.hidden = true;

                    }});
            },

            deleteStoreEvent: function(storeEvent){

                let view = this;
                let url = '/api/sec/storeevent';

                let params =  {
                    id: storeEvent.id,
                    storeId: this.$store.state.storeId
                }


                this.axios({
                    method: 'delete',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
                    view.$delete(view.storeEventMap, storeEvent.id);
                    view.$helpers.success(view.$t('shift.template.deleted'), view.$t('shift.template.eventDeleted'))

                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Löschen des Events!');
                    console.log(error)
                })

            },

            EditEvent($event, eventT){
                let view = this;
                
                let event = Object.assign({}, eventT);
                let to = this.$helpers.getMomentFromStringTZ(event.to);
                if(to.hours() == 0 && to.minutes() == 0){
                    //subtract 1 day because brainlets don't understand what an exclusive time range is
                    to.add(-1,'days');
                    event.to = to.format();
                }
                this.$helpers.PopupEditEvent($event, event, function (storeEvent) {
                        storeEvent.from = view.$helpers.getMomentFromStringTZ(storeEvent.from);

                        storeEvent.to = view.$helpers.getMomentFromStringTZ(storeEvent.to);

                        let weekStart = storeEvent.from.startOf('isoWeek').hours(0).minutes(0);
                        let weekEnd = weekStart.clone().add(1,'weeks');
                        if(storeEvent.to.hours() == 0 && storeEvent.to.minutes() == 0){
                            //add 1 day because brainlets don't understand what an exclusive time range is
                            storeEvent.to.add(1,'days');
                        } 
                        if(storeEvent.from < weekStart){
                            storeEvent.from = weekStart.clone();
                        }
                        if(storeEvent.to > weekEnd){
                            storeEvent.to = weekEnd.clone();
                        }
                        if(storeEvent.from >= weekStart && storeEvent.to <= weekEnd && storeEvent.from != storeEvent.to && storeEvent.from < storeEvent.to){
                             view.editStoreEvent(storeEvent);
                        } else {
                            view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('global.notifications.updateFailed'));
                        }

                    }
                );
            },
            editStoreEvent: function(storeEvent){

                let view = this;
                let url = '/api/sec/storeevent';

                let params = {
                    storeId: this.$store.state.storeId
                };
                let payload = {
                    id: storeEvent.id,
                    name: storeEvent.name,
                    from: storeEvent.from.format(),
                    to: storeEvent.to.format(),
                    federalHoliday: storeEvent.federalHoliday,
                    bankHoliday: storeEvent.bankHoliday,
                    contractHoliday: storeEvent.contractHoliday,
                    description: storeEvent.description,
                    color: storeEvent.color,
                    shiftCreationMode: storeEvent.shiftCreationMode,
                    updateFields: ["name", "from", "to", "federalHoliday", "bankHoliday", "contractHoliday", "description", "color", "shiftCreationMode"]
                };

                this.axios({
                    method: 'put',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
                    view.$set(view.storeEventMap[payload.id], 'name', payload.name);
                    view.$set(view.storeEventMap[payload.id], 'color', payload.color);
                    view.$set(view.storeEventMap[payload.id], 'fromMoment', view.$helpers.getMomentFromStringTZ(payload.from));
                    view.$set(view.storeEventMap[payload.id], 'toMoment', view.$helpers.getMomentFromStringTZ(payload.to));
                    view.$set(view.storeEventMap[payload.id], 'federalHoliday', payload.federalHoliday);
                    view.$set(view.storeEventMap[payload.id], 'bankHoliday', payload.bankHoliday);
                    view.$set(view.storeEventMap[payload.id], 'description', payload.description);
                    view.$set(view.storeEventMap[payload.id], 'from', payload.from);
                    view.$set(view.storeEventMap[payload.id], 'to', payload.to);
                    view.$set(view.storeEventMap[payload.id], 'shiftCreationMode', payload.shiftCreationMode);

                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Update des Events!');
                    console.log(error)
                })

            },
            AddEvent($event, date){
                let eventitems = [];
                let view = this;
                Object.values(this.storeEventMap)/*.filter(event => !event.federalHoliday)*/.forEach(event => {
                    let to = event.toMoment.clone();
                    if(to.hours() == 0 && to.minutes() == 0){
                        //subtract 1 day because brainlets don't understand what an exclusive time range is
                        to.add(-1,'days');
                    }
                    eventitems.push({label: event.name+' '+event.fromMoment.format("DD.MM.YYYY")+' - '+to.format("DD.MM.YYYY"), name: event.name, value: event.id});
                });
                this.$helpers.PopupNewEvent($event, date, eventitems, null, null, function (storeEvent) {
                        storeEvent.from = view.$helpers.getMomentFromStringTZ(storeEvent.from);
                        storeEvent.from.year(storeEvent.fromDate.year());
                        storeEvent.from.month(storeEvent.fromDate.month());
                        storeEvent.from.date(storeEvent.fromDate.date());

                        storeEvent.to = view.$helpers.getMomentFromStringTZ(storeEvent.to);
                        storeEvent.to.year(storeEvent.toDate.year());
                        storeEvent.to.month(storeEvent.toDate.month());
                        storeEvent.to.date(storeEvent.toDate.date());

                        let weekStart = storeEvent.from.startOf('isoWeek').hours(0).minutes(0);
                        let weekEnd = weekStart.clone().add(1,'weeks');
                        
                        if(storeEvent.to.hours() == 0 && storeEvent.to.minutes() == 0){
                            //add 1 day because brainlets don't understand what an exclusive time range is
                            storeEvent.to.add(1,'days');
                        } 
                        if(storeEvent.from < weekStart){
                            storeEvent.from = weekStart.clone();
                        }
                        if(storeEvent.to > weekEnd){
                            storeEvent.to = weekEnd.clone();
                        }
                        if(storeEvent.from >= weekStart && storeEvent.to <= weekEnd && storeEvent.from != storeEvent.to && storeEvent.from < storeEvent.to){
                             view.createStoreEvent(storeEvent);
                        } else {
                            view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('global.notifications.updateFailed'));
                        }

                    }
                );
            },
            createStoreEvent: function(storeEvent){

                let view = this;
                let url = '/api/sec/storeevent';

                let params = {
                    storeId: this.$store.state.storeId
                };
                let payload = {
                    name: storeEvent.name,
                    from: this.$helpers.convertDateString(storeEvent.from),
                    to: this.$helpers.convertDateString(storeEvent.to),
                    federalHoliday: storeEvent.federalHoliday,
                    bankHoliday: storeEvent.bankHoliday,
                    contractHoliday: storeEvent.contractHoliday,
                    description: storeEvent.description,
                    color: storeEvent.color,
                    shiftCreationMode: storeEvent.shiftCreationMode,
                    createWithTemplates: storeEvent.createWithTemplates,
                    copyEventId: storeEvent.copyEventId,
                };
                if(payload.shiftCreationMode == 2){
                    payload.createWithTemplates = false;
                }
                if(payload.copyEventId != null && payload.shiftCreationMode != 2){
                    let copyEventFrom = this.$helpers.getMomentFromStringTZ(this.storeEventMap[payload.copyEventId].from);
                    let copyEventTo = this.$helpers.getMomentFromStringTZ(this.storeEventMap[payload.copyEventId].to)

                    let copyDayIndex = copyEventTo.diff(copyEventFrom, 'minutes') > 1440 ?  null: copyEventFrom.isoWeekday();
                    let newDayFrom = this.$helpers.getMomentFromStringTZ(payload.from);
                    let newDayTo = this.$helpers.getMomentFromStringTZ(payload.to);

                    let newDayIndex = newDayTo.diff(newDayFrom, 'minutes') > 1440 ?  null : newDayFrom.isoWeekday();
                    payload.copyDayIndex = copyDayIndex;
                    payload.newDayIndex = newDayIndex;
                    
                }

                this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    let event = response.data.data;
                    let eventId = response.data.data.id;

                    let fromMoment = view.$helpers.getMomentFromStringTZ(response.data.data.from);
                    let toMoment = view.$helpers.getMomentFromStringTZ(response.data.data.to);

                    view.$store.commit('invalidateState', { states: [ 'holidayMapState' ] })
                    
                    view.$set(view.storeEventMap, eventId, response.data.data);
                    view.$set(view.storeEventMap[eventId], 'fromMoment', fromMoment);
                    view.$set(view.storeEventMap[eventId], 'toMoment', toMoment);
                    view.$helpers.success(this.$t('store.events.creationSuccessful'), this.$t('store.events.creationSuccessful'))
                    if(storeEvent.copyEventId == null && storeEvent.createWithTemplates && event.shiftCreationMode != 2){
                        let templates = [];
                        let validFrom = fromMoment.clone().startOf('week');
                        let validTo = fromMoment.clone().endOf('week').add(1, 'days').startOf('day');
                        view.loadShiftTemplatesPagedCompletely(validFrom, validTo)
                        .then(data => {
                            let shiftTemplates = data;
                            shiftTemplates.filter(s => s.eventId == null).forEach(s => {
                                let overlapsEvent = false;
                                let fromUtc = view.$helpers.getMomentFromStringTZ(s.from, 'HH:mm');
                                let toUtc = view.$helpers.getMomentFromStringTZ(s.to, 'HH:mm')
                                let templateFromMoment = fromMoment.clone().hours(fromUtc.hours()).minutes(fromUtc.minutes());
                                let templateToMoment = fromMoment.clone().hours(toUtc.hours()).minutes(toUtc.minutes());
                                let breakFromMoment = null;
                                if(s.breakFrom){
                                    let breakFromUtc = view.$helpers.getMomentFromStringTZ(s.breakFrom, 'HH:mm');
                                    breakFromMoment = fromMoment.clone().hours(breakFromUtc.hours()).minutes(breakFromUtc.minutes());
                                }
                                let weekDays = [];
                                s.weekDays.forEach(w => {
                                    templateFromMoment.isoWeekday(w);
                                    templateToMoment.isoWeekday(w);
                                    if(templateToMoment <= templateFromMoment){
                                        templateToMoment.add(1,'days')
                                    }
                                        
                                    if(toMoment > templateFromMoment && fromMoment < templateToMoment && templateFromMoment >= fromMoment){
                                        weekDays.push(w);
                                    }
                                        
                                })
                                if(weekDays.length > 0){
                                    let tempTemplate = JSON.parse(JSON.stringify(s));
                                    tempTemplate.weekDays = weekDays;
                                    tempTemplate.eventId = eventId;
                                    tempTemplate.from = templateFromMoment;
                                    tempTemplate.to = templateToMoment;
                                    tempTemplate.breakFrom = breakFromMoment;
                                    templates.push(tempTemplate);
                                }
                                
                            });
                            if(templates.length > 0){
                                view.CreateShiftTemplateMulti(templates);
                            }
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Laden der Schichtpläne!');
                            console.log(error)
                        })

                        
                    }
                }).catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createFailed'));
                    console.log(error)
                })

            },
            CreateShiftTemplateMulti: function(shiftTemplates){
                //console.log(JSON.stringify(shiftTemplate));
                let view = this;
                let url = '/api/sec/shifttemplate/multi';
                
                let params = {
                    storeId: this.$store.state.storeId
                }
                let payload = {
                    requests: []
                }
                
                shiftTemplates.forEach( shiftTemplate => {
                    let from = shiftTemplate.from;
               
                    let to = from.clone().hours(shiftTemplate.to.hours()).minutes(shiftTemplate.to.minutes());
                    
                    if(to <= from){
                        to = to.add(1, 'days');
                    } 

                    let breakValue = shiftTemplate.breakValue;
                    let breakFrom = shiftTemplate.breakFrom;
                    let invalidBreak = false;
                    let invalidSpot = shiftTemplate.spotId ? false : true;
                    if(shiftTemplate.breakFrom == null || shiftTemplate.autoBreak){
                        
                        breakValue = view.$helpers.CalculateAutoBreakValueForPlanShift(false, from, to, view.storeSettings);
                    
                        breakFrom = null;
                    } else {
                        breakFrom = from.clone().hours(breakFrom.hours()).minutes(breakFrom.minutes());

                        if(breakFrom < from){
                            breakFrom.add(1, 'days');
                        }

                    }

                    let item = {
                        groupId: shiftTemplate.groupId,
                        from: from.format('HH:mm'),
                        to: to.format('HH:mm'),
                        spotId: shiftTemplate.spotId,
                        eventId: shiftTemplate.eventId ? shiftTemplate.eventId : null,
                        count: shiftTemplate.count,
                        description: shiftTemplate.description,
                        skillMultiplier: 1,
                        breakFrom: breakFrom == null ? null : breakFrom.format('HH:mm'),
                        breakValue: breakValue,
                        workValueMultiplier:1,
                        workValue: -1,
                        holidayWorkValue: -1,
                        weekDays: shiftTemplate.weekDays ? shiftTemplate.weekDays : [],
                    }
                    payload.requests.push(item);
                })
                
                if(payload.requests.length > 0){
                    this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: payload
                    }).then(response => {
                        view.$helpers.success(this.$t('store.events.creationSuccessful'), 'Schicht Template wurden erfolgreich erstellt')
                        
                    }).catch(function (error) {
                        view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('store.events.shiftTemplateCreationFailed'));
                    })
                }
            },
            MouseOnEvent($event, event){
                this.eventOnHover = event;
                var box = $event.currentTarget.getBoundingClientRect();
                this.eventBoxX = box.left - (box.width * .5);
                this.eventBoxY = box.bottom + 5;
            },
            refresh(){
                var view = this;
                this.loading = true;

                view.$helpers.GetUiDataMap()
                .then(map=> {
                    view.updateUIData(map);
                    return view.loadStoreEvents();
                }).then(response=> {
                    view.updateStoreEvents(response.data);
                    return view.loadActiveEmployees();
                }).then(response => {
                    view.employeeMap = {};
                    view.employees = response.data;
                    view.employees.forEach(e => {
                        view.employeeMap[e.id] = e;
                        var employeeTemp = {name: e.firstName + ' ' + e.lastName, employee: e};
                        employeeTemp.progressCurrent = 15;
                        employeeTemp.progressMax = 25;
                        employeeTemp.picture = view.GetProfilePictureUrl(e);
                        employeeTemp.timeFrames = [];
                        e.displayData = employeeTemp;
                    });
                    return view.loadEmployeePreferences()
                }).then(response => {
                    view.preferences = response.data;
                    view.preferences.forEach(p => {
                        p.fromDate = p.date = view.$helpers.getMomentFromStringTZ(p.from, 'YYYY-MM-DDTHH:mmZ');
                        p.toDate = view.$helpers.getMomentFromStringTZ(p.to, 'YYYY-MM-DDTHH:mmZ');
                    });
                    return  view.loadBusinessUnits()
                }).then(response => {
                    view.businessUnits = response.data;
                    view.businessUnitsMap = {};
                    view.businessUnits.forEach(b => view.businessUnitsMap[b.id] = b);
                    return view.loadSpots();
                }).then(response => {
                    view.spots = response.data;
                    view.spotMap = {};
                    view.spots.forEach(s => view.spotMap[s.id] = s);
                    view.LoadGrid();
                    view.loading = false;
                });
                    
                this.$forceUpdate();

            },
            loadShiftTemplatesPagedCompletely : function(from, to, page = 1, data = []) {

                let url = '/api/sec/shifttemplate';
                let params = {
                    storeId: this.$store.state.storeId,
                    validFrom: from.format(),
                    validTo: to.format(),
                    validGroup: true,
                    page: page,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                
                }).then(response => {

                    if (response.data.length < 1 ) {
                        return data;
                    } else {
                        data.push(...response.data);
                        return this.loadShiftTemplatesPagedCompletely (from, to, page+1, data);
                    }


                })


            },
            
            LoadGrid(){
            },
            TimeDiff(a, b){
                return b._d.getTime() - a._d.getTime();
            },
            OpenCalendarPopup($event, column, row){
                if($(window.mouse.element).closest('.fa-stack').length > 0) return; //here I put window.mouse.element because $event.currentTarget will hit the parent first and not the event add node
                var view = this;
                this.dayInfoState = {
                    toggled: true,
                    column: column,
                    row: row,
                    employees: row.employees.slice(),
                    event: row.event,
                    elRelative: $event.currentTarget,
                    preferences: this.preferences,
                    date: row.date.clone(),
                    OnDeletePreference: this.PreferenceDeleted,
                    SwitchDate: this.OpenCalendarPopupByDate,
                };
            },
            OpenCalendarPopupByDate(date){
                var view = this;
                var column = this.columns.find(c => c.date.month() === date.month());
                var row = column.rows.find(r => r.date.date() === date.date());
                this.dayInfoState = {
                    toggled: true,
                    column: column,
                    row: row,
                    employees: row.employees.slice(),
                    event: row.event,
                    preferences: this.preferences,
                    date: row.date.clone(),
                    OnDeletePreference: this.PreferenceDeleted,
                    SwitchDate: this.OpenCalendarPopupByDate
                };
            },
            PreferenceDeleted(preference){
                this.preferences = this.preferences.filter(p => p.id !== preference.id);
                this.LoadGrid();
                this.$forceUpdate();
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            updateEmployees: function(data) {
                // set employee data
                //console.log(data);
                let overviewA = [];
                var i;
                var roster = this;
                let tEmployeeMap = {};
                for (i = 0; i < data.length; i++) {
                    data[i].shiftsDate = {};
                    data[i].picture = this.GetProfilePictureUrl(data[i]);
                    tEmployeeMap[data[i].id] = data[i];
                    overviewA.push(data[i]);

                }
                this.employeeMap = tEmployeeMap;
                this.employees = overviewA;
                this.employees.sort( this.sortByName );
                //this.employeesFiltered = this.employees.slice();

            },
            sortByName: function(a,b){
              var x = a.firstName + " " + a.lastName;
              var y = b.firstName + " " + b.lastName;
              if ( x.toUpperCase() < y.toUpperCase() ) return -1;
              if ( x.toUpperCase() > y.toUpperCase() ) return 1;
              return 0;
            },
            
            updateUIData: function(data){
                this.uiData = data;
                let stateMap =  {};
                let typeMap = {};
                for(let i = 0; i < data.employeeAvailabilityStates.length; i++){
                    let employeeAvailabilityState = data.employeeAvailabilityStates[i];
                    stateMap[employeeAvailabilityState.id] = employeeAvailabilityState;
                    employeeAvailabilityState.show = true;
                }
                 for(let i = 0; i < data.employeeAvailabilityTypes.length; i++){
                    let employeeAvailabilityType = data.employeeAvailabilityTypes[i];
                    typeMap[employeeAvailabilityType.id] = employeeAvailabilityType;
                    employeeAvailabilityType.show = true;
                }
                this.employeeAvailabilityStates = data.employeeAvailabilityStates;
                this.employeeAvailabilityTypes = data.employeeAvailabilityTypes;
                this.employeeAvailabilityStateMap = stateMap;
                this.employeeAvailabilityTypeMap = typeMap;
            },
            loadActiveEmployees : function() {
                  let url = '/api/sec/employee';
                  let params = {
                      storeId: this.$store.state.storeId,
                      activeAtFrom: this.$store.state.rosterFromTo.from,
                      activeAtTo: this.$store.state.rosterFromTo.to,
                      active: true
                  };


                  return this.axios({
                      method: 'get',
                      params: params,
                      headers: {
                          'AUTHORIZATION': "bearer "+this.$store.state.jwt
                      },
                      url: url
                  })

              },
            loadEmployeePreferences : function() {

                let url = '/api/sec/employeepreference';

                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');


                return this.axios({
                method: 'get',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url
            })
            },
            loadBusinessUnits : function() {

                let url = '/api/sec/businessunit';

                let params = {
                    storeId: this.$store.state.storeId,
                };


                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadSpots : function() {

                let url = '/api/sec/spot';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            loadStoreEvents: function() {
                let from = this.$helpers.getMomentTZ().year(this.rosterFromTo.year).startOf('year');
                let to = from.clone().add(1,'years').startOf('year');
                let url = '/api/sec/storeevent';
                let params = {
                    storeId: this.$store.state.storeId,
                    from: from.format(),
                    to: to.format(),
                    active: true,
                };
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                });
            },
            updateStoreEvents: function(data){
                let i;
                let tstoreevents = {}
                for (i = 0; i < data.length; i++) {
                    let item = data[i];
                    item.fromMoment = this.$helpers.getMomentFromStringTZ(item.from);
                    item.toMoment = this.$helpers.getMomentFromStringTZ(item.to);

                    tstoreevents[data[i].id] = item;

                }
                this.storeEventMap = tstoreevents;
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .calendar-view{
        position: relative;
    }

    .calendar-view > .header{
        background:  var(--contrast-1);
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 60px;
        text-align: center;

    }

    .options{
        margin-top: 20px;
    }

    .options .label{
        text-align: center;
        border-radius: 5px;
        transition: .2s;
        height: 25px;
        width: 35px;
        border: 1px solid var(--contrast-5);
        border-right: none;
        border-radius: 0;
        line-height: 190%;
        cursor: pointer;
    }
    .options .label:first-child{
        border-radius: 5px 0 0 5px;
    }
    .options .label:last-child{
        border-radius: 0 5px 5px 0;
        border-right: 1px solid var(--contrast-5);
    }
    .options .label.selected, .options .label:hover{
        background: #6d8d23;
        color: white;
    }

    .grid{
        text-align: center;
        position: relative;
        height: 100%;
    }

    .column{
        display: inline-block;
        width: calc((100% / 12) - 20px);
        position: relative;
        box-shadow: inset 1px -1px 0 0px #cccccc,inset -1px -1px 0 0px #cccccc;
        float: left;
        left: 127px;
        margin-left: -1px;
        margin-bottom: 50px;
        margin-top: 50px;
    }

    .column > .header{
        position: relative;
        display: block;
        width: 100%;
        height: 30px;
        box-shadow: inset -2px -2px 0 -1px #cccccc;
    }
    .column > .header .today-background{
        display: none;
    }

    .column.today > .header .today-background{
        display: inline-block;
        background: #e51c50;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 5px;
        margin: auto;
        width: calc(100% - 10px);
        height: 35px;
        border-radius: 5px;
        z-index: -1;
    }

    .column.today > .header .label{
        color: white;
    }
    .column > .header .label{

        width: 100%;
        text-align: center;
        color: var(--contrast-4);
        font-weight: 400;
        font-size: 16px;
        line-height: 14px;
    }

    .row{
    display: block;
    width: 100%;
    height: 40px;
    position: relative;
    box-shadow: 0px -1px 0 0px #cccccc;
    margin-left: -1px;
        cursor: pointer;
    }
    .today-border{
        display: none;
    }
    .column.today .row.today .today-border{
        box-shadow: inset 0 0 0 2px #e51c50;
        width: calc(100% - 0px);
        height: calc(100% + 1px);
        pointer-events: none;
        left: 1px;
        top: -1px;
        position: absolute;
        z-index: 11;
        display: inline-block;
    }
    .row > .header{
        display: block;
        width: 42px;
        margin-top: -1px;
        height: 40px;
        position: absolute;
        left: -40px;
        background: #cccccc;
        border-radius: 100px 0 0 100px;
        color: white;
        padding-left: 10px;
    }
    .row.today > .header{
        background: #e51c50;
    }
    .row > .header .label{
        color: white;
        font-size: 20px;
        line-height: 180%;
    }
    .row > .holiday{
        position: absolute;
        background: #6d8d23;
        height: 17px;
        width: 17px;
        max-width: 75px;
        left: 3px;
        top: 1px;
        border-radius: 100px;
        color: white;
        font-size: 10px;
        text-align: right;
        padding-right: 6px;
        line-height: 15px;
    }
    .row > .holiday-request{
        position: absolute;
        background: #ddbd1d;
        height: 17px;
        width: 17px;
        right: 41px;
        top: 1px;
        border-radius: 100px;
        color: white;
        font-size: 10px;
        line-height: 15px;
        text-align: center;
    }
    .row.no-event > .holiday-request{
        right: 1px;
    }
    .row > .sick{
        position: absolute;
        background: #e51c50;
        height: 17px;
        width: 17px;
        right: 41px;
        bottom: 2px;
        border-radius: 100px;
        color: white;
        font-size: 10px;
        line-height: 15px;
        text-align: center;
    }
    .row.no-event > .sick{
        right: 1px;
    }
    .row > .event{
        position: absolute;
        background: #d9d9d9;
        height: 40px;
        width: 40px;
        right: 0;
        top: 0;
        font-size: 10px;
        overflow: hidden;
        line-height: 9px;
        /*display: flex;
        padding: 2px;
        align-items: center;
        justify-content: center;*/
    }
    .row > .event.shadow{
        position: absolute;
        box-shadow: inset -20px 0px 2px -17px #d9d9d9 !important;
        background: none;
        height: 40px;
        width: 40px;
        right: 0;
        top: 0;
        font-size: 10px;
        pointer-events: none;
    }

    .row.hide > *:not(.header):not(.event):not(.info){
        opacity: 0;
        pointer-events: none;
    }

    .event-info{
        position: fixed;
        margin: auto;
        display: inline-block;
        background: white;
        box-shadow: 4px 4px 5px 3px  rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        opacity: 1;
        z-index: 10;
    }

    .event-info .header{
        position: relative;
        width: 100%;
        font-weight: 600;
        text-align: center;
    }

    .event-info .description{
        position: relative;
        width: 100%;
        text-align: center;
    }
  @keyframes spin {
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }


    .add{
        opacity: 0;
        transition: .2s;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 7px;
        top: 10px;
    }

    .add:hover{
        opacity: 1;
    }
    .add .fa-stack{
        cursor:pointer;
    }


    .fa-plus{
        transform: scale(.7);
    }

    .event:not(.add){
        align-items: flex-end;
    }

    .event.new .fa-circle, .row:hover .event.new .fa-circle{
        color: transparent !important;
    }
    .event.new .fa-plus{
        color: var(--contrast-1);
    }
    .event.new .fa-plus{
        color: transparent !important;
    }
    .row:hover .event.new .fa-plus{
        color: var(--contrast-5)!important;
    }
    .event.new{
        background: none;
    }

    .event.new .add{
        transform: scale(1)!important ;
        opacity: 1 !important;
    }

    .event:not(.add) .fa-stack{
        transform: scale(.8);
        cursor: pointer;
        transition: .2s;
        opacity: 0;
    }
    .event:not(.add):hover .fa-stack{
        opacity: 1;
    }

    .event:not(.add) .fas:not(.fa-circle){
        transform: scale(.5);
    }

    .event{
        overflow: hidden;
    }

    .event:hover{
        z-index: 10;
        overflow: visible;
    }

    .event:hover .container{
        margin-left: 40px;
        width: initial;
        z-index: 10;
        white-space: nowrap;
        padding-right: 60px;
        background:#d9d9d9;
    }


    .event:hover .container:nth-child(even){
        background:#ccc;
    }

    .event:hover .shadow{
        display: none;
    }

    .event:hover .container .label{
        position: relative;
    }

    .event .container .fa-stack{
        position: absolute;
        top: 0;
        right: 5px;
    }

    .event .container .edit{
        right: 25px;
    }

    .event .label{
        position: absolute;
        top: 5px;
        left: 5px;
        width: 100%;
        text-align: left;
        white-space: nowrap;;
    }

    .event .shadow{
        position: absolute;
        top: 0;
        left: initial;
        right: 0;
        width: 50%;
        height: 20px;
        text-align: center;
        white-space: nowrap;
        box-shadow: inset -15px 0 2px -7px #d9d9d9 !important;
    }

    .row > .info{
        position: absolute;
        bottom: 0;
        left: 0;
        width: calc(100% - 40px);
        height: 20px;
        font-size: 10px;
        text-align: left;
        overflow: hidden;
    }

    .info .label{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        text-align: left;
        white-space: nowrap;
        padding-left: 5px;
        padding-bottom: 1px;
    }

    .info .shadow{
        position: absolute;
        top: 0;
        left: initial;
        right: 0;
        width: 50%;
        height: 20px;
        text-align: center;
        white-space: nowrap;
        box-shadow: inset -15px 0 2px -7px var(--bg) !important;
    }

    .event .color{
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 5px;
    }

    .event .container{
        float: left;
        display: inline-block;
        width: 100%;
        height: 20px;
        position: relative;
        clear: both;
    }



    .header.date{
        display: inline-flex;
        align-items: center;
        position: absolute;
        z-index: 10;
        background: none;
        left: 0;
        right: initial;
        width: initial;
        padding: 0 20px;
    }

    .header.date .label{
        color: var(--contrast-4);
        font-family: DistrictProLight;
        font-weight: 200;
    }

    .header.date .label.today{
        font-size: 15px;
        cursor:pointer;
    }

    .header.date .fa-angle-right,.header.date .fa-angle-left{
        color: var(--contrast-4);
        font-size: 20px;
        padding: 5px;
        cursor:pointer;
    }

    .header.date .fa-angle-right:hover,.header.date .fa-angle-left:hover, .header.date .fa-calendar:hover, .header.date .today:hover{
        color: var(--bg) !important;
    }

    .header.date .label.bold{
        font-family: DistrictProBold;
        font-weight: 800;
        margin: -3px 5px 0;
    }

    .header.date .fa-calendar{
        margin: 0 10px;
        font-size: 20px;
    }
</style>
